import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FtoReportContext } from '../novelty-check-report-context';
import { FtoReportState } from '../novelty-check-report-state';
import { Logger } from '@patsnap/tahiti-core';
import { FtoTaskStep } from '@/domains/fto-report/enums';
import { FtoReportTaskStatusModel } from '@/domains/fto-report/models/task-status-model';
import { FtoReportComplexRetrievalService } from '../../complex-retrieval-service';
import { FtoReportTitleService, FtoReportTechFeaturesService } from '../../retrieval-result-report-service';

@injectable()
export class FtoReportSearchFinishedState implements FtoReportState {
    // eslint-disable-next-line max-params
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(FtoReportTitleService)
        private readonly _noveltyCheckReportTitleService: FtoReportTitleService,
        @inject(FtoReportTechFeaturesService)
        private readonly _techFeaturesService: FtoReportTechFeaturesService,
        @inject(FtoReportComplexRetrievalService)
        private readonly _complexRetrievalService: FtoReportComplexRetrievalService,
        @inject(FtoReportTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: FtoReportTaskStatusModel,
    ) { }

    getStep(): FtoTaskStep {
        return FtoTaskStep.SEARCH_END;
    }

    async enter(): Promise<void> {
        // 进入<检索>状态的逻辑
        this._logger.info('进入<检索>状态');
        await Promise.all([
            // 获取新颖性报告名称
            this._noveltyCheckReportTitleService.pullNoveltyCheckReportTitle(),
            // 获取技术特征
            this._techFeaturesService.pullTechFeatures(),
            // 获取搜索结果
            this._complexRetrievalService.search(),
        ]);
    }

    async exit(): Promise<void> {
        // 离开<检索>状态的逻辑
        this._logger.info('离开<检索>状态');
    }

    async handleNext(context: FtoReportContext): Promise<void> {
        await this._actionsBeforeNext();
        // 从<检索>状态进入结果状态
        const resultState = context.getState(FtoTaskStep.REPORT_CREATED);
        await context.transitionTo(resultState);
    }

    async handlePrevious(context: FtoReportContext): Promise<void> {
        // 返回技术特征识别状态
        const techFeatureState = context.getState(FtoTaskStep.TECH_FEATURE_PULL_SUCCESS);
        await context.transitionTo(techFeatureState);
    }

    private async _actionsBeforeNext() {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = FtoTaskStep.REPORT_CREATED;
            return state;
        });
    }
}
